import type { EditorOfflineStoragePlugin } from './editorOfflineStoragePluginType';
import { createPlugin } from './pm-plugins/main';

export const editorOfflineStoragePlugin: EditorOfflineStoragePlugin = () => ({
	name: 'editorOfflineStorage',
	pmPlugins() {
		return [
			{
				name: 'editorOfflineStoragePlugin',
				plugin: createPlugin(),
			},
		];
	},
});
